<template>
  <div>
    <app-navbar showToggle v-on:toggleDrawer="toggleDrawer"/>
    <v-navigation-drawer width="350px" v-model="drawer" absolute temporary>
      <sidebar />
    </v-navigation-drawer>
    <slot />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import AppNavbar from "./AppNavbar.vue";
import Sidebar from "./Sidebar.vue";

export default Vue.extend({
  data () {
    return {
      drawer: false
    }
  },
  components: {
    AppNavbar,
    Sidebar
  },
  methods: {
    toggleDrawer: function () {
      this.drawer = !this.drawer
    }
  }
});
</script>
